import React, { memo } from 'react';
import PropTypes from 'prop-types';

import AvataImg from 'assets/images/avatarHotel.png';
import { ReactComponent as StarSVG } from 'assets/images/star_purple500.svg';

import styles from './Information.module.scss';

function Information({ place }) {
  const placeName = place?.name || 'Đang tải...';
  const placeAddress = place?.address
    ? `${place.address}${place.ward ? `, ${place.ward}` : ''}${place.district ? `, ${place.district}` : ''}${place.province ? `, ${place.province}` : ''}`
    : 'Đang tải...';
  const placeImage = place?.previewImage || AvataImg;
  const starCount = place?.starRating || 0;

  return (
    <div className={styles.Information}>
      <div className="Information">
        <div className="Information__Avatar">
          <img src={placeImage} alt={placeName} />
        </div>

        <div className="Information__Content InformationContent">
          <span className="InformationContent__Name">
            {placeName}
          </span>

          {starCount > 0 && (
            <div className="InformationContent__Star">
              {Array.from({ length: starCount }, (_, i) => (
                <StarSVG key={i} />
              ))}
            </div>
          )}

          <span className="InformationContent__Address">
            {placeAddress}
          </span>

          <div className="InformationContent__averageRating">
            <p> Điểm trung bình đánh giá:</p>
            <span>
              {place?.ratingOverview}
              /10
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

Information.propTypes = {
  place: PropTypes.instanceOf(Object),
};

Information.defaultProps = {
  place: null,
};

export default memo(Information);
